$(document).on('click', '.ranking-tab__btn', function() {
    $(".ranking-tab__panel, .ranking-tab__btn").removeClass('active')
    $(".ranking-tab__panel").hide()
    var tab = $(this).data('tab')
    $(this).addClass('active')
    $(".ranking-tab__panel[data-panel="+tab+"]").show().addClass('active')
})
if($(".mv-slider").length) {
  var swiper = new Swiper('.mv-slider', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      breakpoints: {
          769: {
              spaceBetween: 0,
              slidesPerView: 2.5,
          },
      }
  });
}

$(window).on('load',function(){
  window.setTimeout(function() {
    $("#fsb_container").remove()
  }, 1000)
});